var _style, _path, _g, _g2, _path2, _circle, _circle2, _circle3, _circle4, _path3, _g3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cover_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1920 1080",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cover_svg__st0{opacity:.34;fill:#dbdbdb}.cover_svg__st3,.cover_svg__st4{opacity:.4;fill:#a0a0a0}.cover_svg__st4{fill:#9b9b9b}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cover_svg__curvy-corner-1",
    className: "cover_svg__st0",
    d: "M1921.5,500.6c-43.9-28.7-97.6-32.5-147-45.5c-68.3-21.7-192,77.5-230.9,34.2 c-33-36.9-230.4-41.8-294.4-90.5c-49.3-36.9,88.9-128,59.1-200.6c-21.2-57,3.8-154.5,13.1-213.7H1922v516.2h-0.5V500.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cover_svg__Group_92",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "cover_svg__Path_13",
    d: "M1422,785.3c1.1,0,2.2-1.1,1.6-2.2v-0.5c-0.5-1.6-2.7-3.2-4.9-2.7c-2.7,0.5-5.4,2.7-5.9,5.4 c-1.1,3.8,0,8.1,3.2,10.8c3.8,3.2,9.2,4.3,14.1,2.7c5.9-2.2,9.7-7.6,10.8-13.6c1.1-7-2.2-14.7-7.6-19c-6.5-4.9-15.8-5.9-23.3-2.7 c-8.6,3.8-14.7,12-15.8,21.7c-1.1,10.3,3.8,21.2,12.5,27.1c9.7,6.5,22.2,7.6,32.5,2.7c11.4-5.4,19-16.8,20.1-29.8 c0.5-14.1-5.4-27.1-17.4-35.3c-12.5-8.1-28.7-9.2-42.3-2.7c-14.1,7.6-23.9,21.7-24.9,38c-0.5,17.4,7.6,33.7,21.7,43.4 c15.8,9.7,35.3,10.8,51.5,2.7c17.4-9.2,28.7-26.5,29.8-46.1c0.5-20.6-9.2-40.1-26.5-51.5c-18.5-11.4-41.2-12.5-60.8-2.7 c-19.5,10.3-33,30.9-34.2,54.2c-1.1,22.8,10.8,46.6,31.4,59.7c20.1,13.1,48.2,14.1,69.9,2.7c22.2-11.4,38-35.8,39.1-62.4 c1.1-26-13.1-53.1-35.8-67.8c-22.8-14.7-54.7-15.8-79.7-2.7c-24.9,13.1-42.8,40.7-43.9,70.5c-1.1,29.2,14.7,59.7,40.7,75.3 c26,16.3,61.3,17.4,88.9,2.7c27.6-14.7,47.2-45.5,48.2-78.7c1.1-32.5-16.8-66.2-45.5-84.1c-28.7-17.9-67.8-19.5-98.1-2.7 c-30.9,16.8-52,50.4-53.1,86.8c-1.1,35.8,18.5,72.6,49.9,91.6c31.4,19.5,74.2,21.2,107.9,2.7c33.7-18.5,57-55.3,57.5-94.3 c1.1-39.1-20.1-79.2-54.7-100.4c-34.2-21.2-80.8-22.2-117.1-2.7c-36.4,19.5-61.3,60.2-62.4,102.5c-1.1,42.3,22.2,85.7,59.1,107.9 c36.9,22.2,87.3,24.4,126.4,2.7c39.1-21.7,66.2-65.1,67.2-110.6c1.1-45.5-23.9-91.6-64-116c-40.1-24.4-93.8-26-135.5-2.7 c-42.3,23.3-70.5,69.9-71.6,118.7c-1.1,49.3,26,98.1,68.9,124.2c42.8,26,100.4,27.6,145.4,2.7c45-24.9,75.3-74.8,76.4-126.9",
    fill: "none",
    stroke: "#a0a0a0",
    strokeWidth: 6.918,
    strokeLinecap: "round",
    strokeMiterlimit: 1.852,
    strokeDasharray: "8.8063,13.837"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cover_svg__dot-group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_4",
    className: "cover_svg__st3",
    cx: 183.7,
    cy: 506,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_5",
    className: "cover_svg__st3",
    cx: 229.7,
    cy: 506,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_6",
    className: "cover_svg__st3",
    cx: 276.4,
    cy: 506,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_7",
    className: "cover_svg__st3",
    cx: 322.4,
    cy: 506,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_8",
    className: "cover_svg__st3",
    cx: 368.5,
    cy: 506,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_9",
    className: "cover_svg__st3",
    cx: 183.7,
    cy: 549.4,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_10",
    className: "cover_svg__st3",
    cx: 229.7,
    cy: 549.4,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_11",
    className: "cover_svg__st3",
    cx: 276.4,
    cy: 549.4,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_12",
    className: "cover_svg__st3",
    cx: 322.4,
    cy: 549.4,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_13",
    className: "cover_svg__st3",
    cx: 368.5,
    cy: 549.4,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_14",
    className: "cover_svg__st3",
    cx: 183.7,
    cy: 593.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_15",
    className: "cover_svg__st3",
    cx: 229.7,
    cy: 593.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_16",
    className: "cover_svg__st3",
    cx: 276.4,
    cy: 593.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_17",
    className: "cover_svg__st3",
    cx: 322.4,
    cy: 593.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_18",
    className: "cover_svg__st3",
    cx: 368.5,
    cy: 593.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_19",
    className: "cover_svg__st3",
    cx: 183.7,
    cy: 636.7,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_20",
    className: "cover_svg__st3",
    cx: 229.7,
    cy: 636.7,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_21",
    className: "cover_svg__st3",
    cx: 276.4,
    cy: 636.7,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_22",
    className: "cover_svg__st3",
    cx: 322.4,
    cy: 636.7,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_23",
    className: "cover_svg__st3",
    cx: 368.5,
    cy: 636.7,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_24",
    className: "cover_svg__st3",
    cx: 183.7,
    cy: 462.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_25",
    className: "cover_svg__st3",
    cx: 229.7,
    cy: 462.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_26",
    className: "cover_svg__st3",
    cx: 276.4,
    cy: 462.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_27",
    className: "cover_svg__st3",
    cx: 322.4,
    cy: 462.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_28",
    className: "cover_svg__st3",
    cx: 368.5,
    cy: 462.6,
    r: 3.8
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "cover_svg__star",
    className: "cover_svg__st3",
    d: "M440.6,842.7l9.7,26l22.2,16.8l-26.5,8.6l-17.4,21.7l-9.7-26l-22.2-16.8l26.5-8.6L440.6,842.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__circle",
    className: "cover_svg__st4",
    cx: 1281.6,
    cy: 975.5,
    r: 13.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__circle-2",
    className: "cover_svg__st4",
    cx: 115.3,
    cy: 320,
    r: 13.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__circle-3",
    className: "cover_svg__st4",
    cx: 350.1,
    cy: 117.8,
    r: 13.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__circle-4",
    className: "cover_svg__st4",
    cx: 1075.6,
    cy: 371.5,
    r: 10.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "cover_svg__curvy-corner-1_1_",
    className: "cover_svg__st0",
    d: "M296.4,1080.2c-16.8-20.6-31.4-46.6-38.5-69.4c-13.1-31.9-14.1-31.4-39.6-49.9 c-21.7-15.8-29.8-30.3-58.6-60.8c-21.7-23.3,1.1-81.4-41.2-95.4c-33.7-9.7-90.5-10.3-125.3-5.9v282L296.4,1080.2z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cover_svg__dot-group_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_4_1_",
    className: "cover_svg__st3",
    cx: 876.1,
    cy: 992.4,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_5_1_",
    className: "cover_svg__st3",
    cx: 922.1,
    cy: 992.4,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "cover_svg__Ellipse_6_1_",
    className: "cover_svg__st3",
    d: "M968.2,988.6c2.2,0,3.8,1.6,3.8,3.8s-1.6,3.8-3.8,3.8s-3.8-1.6-3.8-3.8 C964.4,990.2,966.1,988.6,968.2,988.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_7_1_",
    className: "cover_svg__st3",
    cx: 1014.3,
    cy: 992.4,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_8_1_",
    className: "cover_svg__st3",
    cx: 1060.4,
    cy: 992.4,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_9_1_",
    className: "cover_svg__st3",
    cx: 876.1,
    cy: 1036.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_10_1_",
    className: "cover_svg__st3",
    cx: 922.1,
    cy: 1036.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "cover_svg__Ellipse_11_1_",
    className: "cover_svg__st3",
    d: "M968.2,1032c2.2,0,3.8,1.6,3.8,3.8s-1.6,3.8-3.8,3.8s-3.8-1.6-3.8-3.8 C964.4,1034.1,966.1,1032,968.2,1032z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_12_1_",
    className: "cover_svg__st3",
    cx: 1014.3,
    cy: 1036.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_13_1_",
    className: "cover_svg__st3",
    cx: 1060.4,
    cy: 1036.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_14_1_",
    className: "cover_svg__st3",
    cx: 876.1,
    cy: 1079.7,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_15_1_",
    className: "cover_svg__st3",
    cx: 922.1,
    cy: 1079.7,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "cover_svg__Ellipse_16_1_",
    className: "cover_svg__st3",
    d: "M968.2,1075.9c2.2,0,3.8,1.6,3.8,3.8c0,2.2-1.6,3.8-3.8,3.8s-3.8-1.6-3.8-3.8 C964.4,1077.5,966.1,1075.9,968.2,1075.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_17_1_",
    className: "cover_svg__st3",
    cx: 1014.3,
    cy: 1079.7,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_18_1_",
    className: "cover_svg__st3",
    cx: 1060.4,
    cy: 1079.7,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_19_1_",
    className: "cover_svg__st3",
    cx: 876.1,
    cy: 1123.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_20_1_",
    className: "cover_svg__st3",
    cx: 922.1,
    cy: 1123.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "cover_svg__Ellipse_21_1_",
    className: "cover_svg__st3",
    d: "M968.2,1119.3c2.2,0,3.8,1.6,3.8,3.8c0,2.2-1.6,3.8-3.8,3.8s-3.8-1.6-3.8-3.8 C964.4,1120.9,966.1,1119.3,968.2,1119.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_22_1_",
    className: "cover_svg__st3",
    cx: 1014.3,
    cy: 1123.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_23_1_",
    className: "cover_svg__st3",
    cx: 1060.4,
    cy: 1123.6,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_24_1_",
    className: "cover_svg__st3",
    cx: 876.1,
    cy: 949.5,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_25_1_",
    className: "cover_svg__st3",
    cx: 922.1,
    cy: 949,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "cover_svg__Ellipse_26_1_",
    className: "cover_svg__st3",
    d: "M968.2,945.2c2.2,0,3.8,1.6,3.8,3.8s-1.6,3.8-3.8,3.8s-3.8-1.6-3.8-3.8 S966.1,945.2,968.2,945.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_27_1_",
    className: "cover_svg__st3",
    cx: 1014.3,
    cy: 949,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cover_svg__Ellipse_28_1_",
    className: "cover_svg__st3",
    cx: 1060.4,
    cy: 949,
    r: 3.8
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "cover_svg__star_1_",
    className: "cover_svg__st3",
    d: "M1143.4,91.7l7,18.5l15.8,12l-19,6.5l-12,15.2l-7-18.5l-15.8-12l19-6.5L1143.4,91.7z"
  })));
}

export default SvgCover;